'use client';

import type { Entry } from 'contentful';
import { useState } from 'react';
import type { CategoryTypes } from '../components';
import { propsMapper } from '../utils/propsMapper';

export const useCategoryStack = (categories: Entry[]) => {
    const initStack = [
        {
            categories: propsMapper<CategoryTypes>(categories),
        },
    ];
    const [categoryStack, setCategoryStack] =
        useState<CategoryTypes[]>(initStack);

    return {
        currentCategories: categoryStack[categoryStack.length - 1],
        categoryStack,
        handleCategoryClick: (category: CategoryTypes) => {
            if (category.categories?.length) {
                category.categories.sort(
                    (a: CategoryTypes, b: CategoryTypes) =>
                        Number(b.shopAllCategory ?? 0) -
                        Number(a.shopAllCategory ?? 0)
                );
                return setCategoryStack([...categoryStack, category]);
            }
            return null;
        },
        handleBackClick: () =>
            categoryStack.length > 1
                ? setCategoryStack(categoryStack.slice(0, -1))
                : null,
    };
};
